<template>

<section class="common _component-page">
    <InputValidationComponent />
</section>

<section class="common _component-page">
    <MySelectRoomSelectListComponent />
</section>

</template>


<script>
    import EndUserLayout from '@/Layouts/EndUserLayout'

    //ComponentList.vue
    import InputValidationComponent from '@/components/EndUser/ComponentList/01InputValidation'
    import MySelectRoomSelectListComponent from '@/components/EndUser/ComponentList/22MySelectRoomSelectList'

    export default {
        layout: EndUserLayout,
        components: {
            InputValidationComponent,
            MySelectRoomSelectListComponent
        },
    };
</script>

<style>
._component-page .form_text {
    margin-bottom: 4rem;
}
</style>